<app-card-lg [title]="'Transactions'">
  <div *appLoading="loading$ | async"></div>
  @if ((loading$| async) === false) {
    @for (transaction of transactions$ | async; track transaction) {
      <app-transactions-list-item [transaction]="transaction"></app-transactions-list-item>
    }
  }
</app-card-lg>
